import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-email-confirmation',
  standalone: true,
  imports: [],
  templateUrl: './email-confirmation.component.html',
  styleUrl: './email-confirmation.component.css'
})
export class EmailConfirmationComponent {
  emailToken: any;

  constructor(private auth: AuthService, private route: ActivatedRoute) { }
  
  ngOnInit() {
    this.emailToken = null;
    const params = this.route.snapshot.queryParams;
    if (params['token']) {
      const rawToken = params['token'];
      this.emailToken = decodeURIComponent(rawToken || '');
      localStorage.setItem('emailtoken', this.emailToken);
    }

    this.auth.logout();
  }  
}
